export const presentation_video = require('./presentation_box.mp4');
